export const removeFileExtension = filename => {
  return filename.substring(0, filename.lastIndexOf('.')) || filename;
};

export const getFileExtension = filename => {
  const parts = filename.split('.');
  return parts.length > 1 ? parts.pop() : '';
};
